import React from 'react';

const CartBar = () => {
    return (
        <div className="bg-danger">
            <div className="container">
                <div style={{textAlign: 'right'}}>
                    <a className="text-light" href="#">Cart <i className="fas fa-shopping-cart"></i></a>
                </div>
            </div>
        </div>
    )
}


export default CartBar
